import axios from 'axios'
import {baseURL} from '@/services/baseURL.js'
import Store from '@/store';

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
  },
  withCredentials: false,
})

apiClient.interceptors.request.use(function(config) {
const token = Store.state.Pengguna.ev_id;
  //const token ='okennd72q65sjavna61n5qq6i7';
  if(token) {
      config.headers.Authorization = `${token}`;
      console.log('request intercepted, token set to headersadsadsadsa')
  }else{
    console.log('token not set',token)
  }
  console.log('axios config in interceptor',config)
  return config;
}, function(err) {
  return Promise.reject(err);
});

const perananLabel=[]
perananLabel[1]='Pengguna Asas'
perananLabel[2]='Pentadbir Sistem'
perananLabel[3]='Helpdesk'

export default {
  loginPengguna(Pengguna){
    return apiClient.post('/login/login.php',Pengguna)
  },
  getDashboard(search) {
    return apiClient.get('/pemanggil/dashboard.php', { params: search })
  },
  getPenggunaInfo(search) {
    return apiClient.get('/pengguna/senarai_pengguna_info.php', { params: search })
  },
  getPenggunaData(search) {
    return apiClient.get('/pengguna/senarai_pengguna_data.php', { params: search })
  },
  setUpdatePengguna(Pengguna){
    return apiClient.post('/pengguna/kemaskini_pengguna.php',Pengguna)
  },
  getPenggunaInfoParam(Search) {
    return apiClient.get('/api/pengguna/senarai_pengguna_info.php',{params:Search})
  },
  getPenggunaDataParam(Search) {
    return apiClient.get('/api/pengguna/senarai_pengguna_data.php',{params:Search})
  },
  setKemaskiniPengguna(Pengguna){
    return apiClient.post('/api/pengguna/kemaskini_pengguna.php',Pengguna)
  },
  setTambahPengguna(Pengguna){
    return apiClient.post('/pengguna/tambah_pengguna.php',Pengguna)
  },
  testLogin(Search){
    console.log('dalam test login service ')
    return apiClient.post('/login/sessionStatus.php',Search)
  },
  loadSession(QueryObj) {
    return apiClient.get('/login/loadSession.php',{params:QueryObj})
  },
  ev_logout() {
    return apiClient.get('/login/ev_logout.php')
  },
  getPeranan(roleId){
    if(roleId>0){
      return perananLabel[roleId]
    }else{
      return 'Tiada Peranan!'
    }
  },
}
